import type {
  DeliveryChargeFulfillmentType,
  DeliveryMethodContainerRuleUnitType,
  DeliveryMethodContainerRulesContainerTypesType,
  FulfillmentTypeCreateRequestType,
} from "@sellar-io/api-v2/types";

export type DeliveryMethodCreateAvailableContainer =
  DeliveryMethodContainerRulesContainerTypesType[number];

export const getDeliveryMethodCreateContainerKey = (
  container: DeliveryMethodCreateAvailableContainer,
) => `${container.containerType}-${container.volume}-${container.displayUnit}`;

export const buildDeliveryMethodCreateRequest = ({
  name,
  fulfillmentType,
  availableContainers,
  excludedContainerKeys,
}: {
  name: string;
  fulfillmentType: DeliveryChargeFulfillmentType;
  availableContainers: DeliveryMethodContainerRulesContainerTypesType;
  excludedContainerKeys: Set<string>;
}): FulfillmentTypeCreateRequestType => ({
  name,
  fulfillmentType,
  DeliveryMethodContainerRules: availableContainers
    .filter((container) =>
      excludedContainerKeys.has(getDeliveryMethodCreateContainerKey(container)),
    )
    .map((container) => ({
      containerType: container.containerType,
      unit: container.displayUnit as DeliveryMethodContainerRuleUnitType,
      volume: container.volume,
    })),
});
